// extracted by mini-css-extract-plugin
export var borderRadius = "_bf-4";
export var large = "_bf-3";
export var logoContainer = "_bf-0";
export var nameLogo = "_bf-2";
export var small = "_bf-1";